<template>
  <v-container fill-height align-center>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form ref="form" @submit="validateAndSubmit" onSubmit="return false;">
          <v-card id="content_card">
            <v-text-field
              type="mail"
              class="input_field"
              v-model="mail"
              :rules="mail_rules"
              label="Your E-Mail Address"
            ></v-text-field>

            <v-text-field
              :append-icon="show_password ? 'visibility' : 'visibility_off'"
              class="input_field"
              :type="show_password ? 'text' : 'password'"
              v-model="password"
              :rules="password_rules"
              label="Your Password"
              @click:append="show_password = !show_password"
            ></v-text-field>

            <v-text-field
              :append-icon="
                show_password_repetition ? 'visibility' : 'visibility_off'
              "
              class="input_field"
              :type="show_password_repetition ? 'text' : 'password'"
              v-model="repetition"
              :rules="password_repetition_rules"
              label="Repeat your Password"
              @click:append="
                show_password_repetition = !show_password_repetition
              "
            ></v-text-field>
            <v-alert
              :value="show_alert"
              :type="alert_type"
              transition="scale-transition"
              >{{ alert_text }}</v-alert
            >

            <v-btn
              class="primary"
              rounded
              block
              :loading="show_loading"
              :disabled="show_loading"
              type="submit"
              >Sign up</v-btn
            >

            <v-btn
              block
              outlined
              rounded
              class="mt-8"
              :disabled="show_loading"
              v-on:click="go_to_login"
              >Already got an account?</v-btn
            >
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* global firebase */
import { mapActions } from "vuex";

export default {
  name: "SignUp",
  data() {
    return {
      show_alert: false,
      alert_type: "success",
      alert_text: "",
      show_loading: false,
      show_password: false,
      show_password_repetition: false,
      mail: null,
      password: null,
      valid: null,
      repetition: null,
      mail_rules: [
        v => !!v || "E-Mail cannot be empty!",
        v =>
          /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(
            v
          ) || "Please enter a valid E-Mail address!"
      ],
      password_rules: [
        v => !!v || "Password cannot be empty!",
        v =>
          (v || "").length >= 10 ||
          "Your password needs to be at least 10 characters long!",
        v =>
          /\d/.test(v) || "Your password needs to contain at least one number!",
        v =>
          /[a-z]/.test(v) ||
          "Your password needs to contain at least one lowercase letter!",
        v =>
          /[A-Z]/.test(v) ||
          "Your password needs to contain at least one uppercase letter!"
      ],
      password_repetition_rules: [
        v => v === this.password || "Passwords do not match"
      ]
    };
  },
  methods: {
    ...mapActions("user", {
      sign_up_mail_password: "sign_up_with_mail_and_password"
    }),
    async validateAndSubmit() {
      this.show_alert = false;
      this.show_loading = false;

      if (this.$refs.form.validate()) {
        this.show_loading = true;

        this.sign_up_mail_password({ mail: this.mail, password: this.password })
          .then(() => {
            firebase
              .auth()
              .currentUser.sendEmailVerification()
              .then(() => {
                this.show_alert = true;
                this.alert_type = "success";
                this.alert_text = "Successfully Created Account.";

                this.show_loading = false;
                this.$router.push({
                  path: "/verify",
                  query: {
                    auth_requester: this.auth_requester,
                    auth_requester_title: this.auth_requester_title
                  }
                });
              });
          })
          .catch(() => {
            this.show_alert = true;
            this.alert_type = "error";
            this.alert_text = "Could not create account.";

            this.show_loading = false;
          });
      } else {
        this.show_alert = true;
        this.alert_type = "error";
        this.alert_text = "Please fix the errors above.";
      }
    },
    go_to_login() {
      this.$router.push("/signin");
    }
  }
};
</script>

<style>
.input_field {
  margin: 8px;
}
#content_card {
  padding: 8px;
}
</style>
